export async function purify<T>(promises: Promise<T>[]): Promise<[T[], Error[]]> {
    const values: T[] = [];
    const errors: Error[] = [];

    // eslint-disable-next-line no-restricted-syntax
    for (const promise of promises) {
        await promise
            .then((value) => {
                values.push(value);
            })
            .catch((error) => {
                errors.push(error);
            });
    }

    return [values, errors];
}
